
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.5 20H13v-5.59L15.54 17A1 1 0 0017 17a1 1 0 000-1.41l-4.24-4.25a1 1 0 00-1.42 0l-4.29 4.2a1 1 0 000 1.41 1 1 0 001.41 0L11 14.41V20H5.5a1 1 0 00-1 1 1 1 0 001 1h13a1 1 0 001-1 1 1 0 00-1-1zM12 10a4 4 0 10-4-4 4 4 0 004 4zm0-6.67A2.67 2.67 0 119.33 6 2.68 2.68 0 0112 3.33zM12 7a1 1 0 10-1-1 1 1 0 001 1z"}})])
          )
        }
      }
    